import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { getDocumentHelper } from '../../../../actions/utility-actions';
import { FlatButton } from '../../../../components/button/FlatButton';
import { DialogHeader } from '../../../../components/dialog/DialogHeader';
import { DialogTrigger } from '../../../../components/dialog/DialogTrigger';
import { OrderQuantity } from '../../../../modules/reports/models/order-quantity';
import { StickersReportDocument } from '../../../../models/production/stickers-report-document';

export const ServiceCenterStickersReport = () => {

    const [isOpen, setIsOpen] = React.useState(false);
    const [orders, setOrders] = React.useState([] as OrderQuantity[]);
    const dispatch = useDispatch();

    /**
     * Handle the dialog open click
     */
    const onOpenClick = () => {
        setIsOpen(true);
    };

    /**
     * Handle the diaog close click
     */
    const onCloseClick = () => {
        setOrders([]);
        setIsOpen(false);
    };
   
    /**
     * Format the dates and initiate the AccountMate report command
     */
    const runReport = () => {
        if (canRun()) {
            const req = new StickersReportDocument(orders);
            dispatch(getDocumentHelper(req));
            onCloseClick();
        }
    };

    function canRun() {
        if (orders.length == 0) {
            return false
        }

        for (let order of orders) {
            if (!order.id || !order.quantity) {
                return false;
            }
        }

        return true;
    }

    const onOrderChange = (e: any, idx: number) => {
        const tmpOrders = [...orders];
        const tmpOrder = { ...orders[idx] };
        tmpOrder.id = e.target.value;
        tmpOrders[idx] = tmpOrder;
        setOrders(tmpOrders);
    };

    const onQuantityChange = (e: any, idx: number) => {
        const tmpOrders = [...orders];
        const tmpOrder = { ...orders[idx] };
        tmpOrder.quantity = e.target.value;
        tmpOrders[idx] = tmpOrder;
        setOrders(tmpOrders);
    };
    
    const removeOrder = (idx: number) => () => {
        const tmpOrders = [...orders];
        tmpOrders.splice(idx, 1);
        setOrders(tmpOrders);
    };

    const addOrder = () => {
        var newOrder = new OrderQuantity();

        const tmpOrders = [...orders];
        tmpOrders.push(newOrder);
        setOrders(tmpOrders);
    };

    return (
        <React.Fragment>
            <div className="report-card-wrap blue">
                <div className="row">
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <h3>Stickers Report</h3>
                                <p>Obtain stickers for chosen orders.</p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <DialogTrigger
                                    onClick={onOpenClick}
                                    text="Run Report" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog
                open={isOpen}
                className="report-dialog"
                onClose={onCloseClick}
                maxWidth="md"
                aria-labelledby="form-dialog-title">

                <DialogHeader>
                    <h1>Stickers</h1>
                </DialogHeader>

                <DialogContent>
                    <div className="row">
                        <div className="col">
                            <p>Choose some Orders and Quantities to print Stickers for.</p>
                        </div>
                    </div>
                    <div className="row">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th style={{ width: '45%' }}>Order Id</th>
                                    <th style={{ width: '45%' }}>Quantity</th>
                                    <th style={{ width: '10%' }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    orders.map((itm: OrderQuantity, idx: number) =>
                                        <tr key={`order-row-${idx}`}>
                                            <td>
                                                <input id={`order_${idx}`}
                                                    value={itm.id}
                                                    onChange={e => onOrderChange(e, idx)}
                                                />
                                            </td>
                                            <td>
                                                <input id={`quantity_${idx}`}
                                                    type="number"
                                                    value={itm.quantity}
                                                    onChange={e => onQuantityChange(e, idx)}
                                                />
                                            </td>
                                            <td>
                                                <button
                                                    id="remove-order"
                                                    onClick={removeOrder(idx)}
                                                    type="button"
                                                    className="btn-icon remove-btn" >
                                                    <i className="la la-minus" />
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                }
                                <tr>
                                    <td colSpan={6}>
                                        <button
                                            id="add-order"
                                            onClick={addOrder}
                                            type="button"
                                            className="btn-icon add-btn" >
                                            Add Order
                                            <i className="la la-plus" />
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </DialogContent>
                <DialogActions>
                    <FlatButton
                        id="stickersNoBtn"
                        text="Cancel"
                        classes="negative"
                        onBtnClick={onCloseClick} />
                    <FlatButton
                        id="stickersYesBtn"
                        text="Go"
                        classes="positive"
                        onBtnClick={runReport} />
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );

};
